import styled from 'styled-components';

export const skeletonCellPadding = {
  vertical: 12,
  horizontal: 24,
};

export const SkeletonRowStyled = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SkeletonCellStyled = styled.div<{ width?: number; height?: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: ${({ height }) => `${height}px`};
  width: ${({ width }) => `${width}px`};
  padding: ${skeletonCellPadding.vertical}px ${skeletonCellPadding.horizontal}px;
  border-bottom: 1px solid #eaecf0;
  white-space: nowrap;
`;

export const SkeletonContainerStyled = styled.div<{ width?: number; height?: number }>`
  display: inline-block;
  height: ${({ height }) => `${height}px`};
  width: ${({ width }) => `${width}px`};
  border-radius: 5px;
  animation: skeleton-loading 1.5s linear infinite alternate;

  @keyframes skeleton-loading {
    0% {
      background-color: hsl(200, 20%, 80%);
    }
    100% {
      background-color: hsl(200, 20%, 95%);
    }
  }
`;
